import { Component, OnInit, Optional, Inject, PLATFORM_ID, InjectionToken, REQUEST } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Request, Response } from 'express';
import { BrandConfigurationService } from '@core-mkt/services/configuration/brand-configuration.service';
import { RESPONSE } from '../../tokens/response.token';

// This component is mostly in charge of returning a 404 when a page or file is not found.
// Tutorial for 404 functionality found here, https://azizwrites.xyz/post/setting-status-code-and-handling-404-pages-in-angular-universal-0232
@Component({
  selector: 'page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: true,
})
export class PageNotFoundComponent implements OnInit {
  constructor(
    @Optional() @Inject(REQUEST) private request: Request,
    @Optional() @Inject(RESPONSE) private response: Response,
    @Inject(PLATFORM_ID) private platformId: InjectionToken<any>,
    private bfs: BrandConfigurationService,
  ) {}

  get url(): string | undefined {
    return this.bfs.url;
  }

  get checkClassName(): string {
    return this.bfs.config.checkClassName;
  }

  ngOnInit(): void {
    if (isPlatformServer(this.platformId) && this.response) {
      this.response.statusCode = 404;
      this.response.statusMessage = '404 - Page Not Found';
    }
  }
}
